import { X } from 'lucide-react'
import { createPortal } from 'react-dom'


// Contenedor modal reutilizable para formularios de alta de status.
// La validación y persistencia del formulario se manejan, a propósito, en las páginas padre.
export default function NewStatusModal({
  isOpen,
  title = 'Add Equipment',
  onClose,
  onSave,
  children,
  saveLabel = 'Add',
  cancelLabel = 'Cancel',
  modalClassName = '',
  saveButtonClassName = '',
  usePortal = false,
  allowOverlayScroll = false,
}) {
  if (!isOpen) {
    return null
  }

  const modalContent = (
    <div
      className= 'fixed inset-0 z-20 flex items-center justify-center bg-[rgba(17,24,39,0.35)] p-4'
    >
      <div 
        className=
          'w-full max-w-[800px] max-h-[500px] overflow-visible rounded-[18px] border border-[#D7DEE8] bg-white shadow-[0_30px_60px_rgba(16,24,40,0.28)]'
      >
        <header className="flex items-center justify-between rounded-t-[18px] bg-[#E8EFFA] px-6 py-4">
          <h3 className="text-[22px] font-semibold text-brand-500">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-[#6A7282] hover:bg-[#DCE6F6]"
            aria-label="Close modal"
          >
            <X size={22} />
          </button>
        </header>

        <div className="space-y-5 px-6 py-6">{children}</div>

        <footer className="flex items-center justify-end gap-8 border-t border-[#E5E7EB] px-6 py-4">
          <button
            type="button"
            onClick={onClose}
            className="flex items-center justify-center gap-2 h-12 min-w-[160px] rounded-xl bg-[#D81D1D] px-5 text-[16px] font-semibold text-white shadow-sm hover:bg-[#C21313]"
          >
            {cancelLabel}
          </button>
          <button onClick={onSave} 
          className="flex items-center justify-center gap-2 h-12 min-w-[160px] rounded-xl bg-[#2563EB] px-5 text-[16px] font-semibold text-white shadow-sm hover:bg-[#1D4ED8]">
            {saveLabel}
          </button>
        </footer>
      </div>
    </div>
  )

  if (usePortal && typeof document !== 'undefined') {
    return createPortal(modalContent, document.body)
  }

  return modalContent
}
